import { Toaster } from "@/components/ui/sonner";
import { PostHogProvider } from "@/providers/posthog-provider";
import { PropsWithChildren } from "react";
import { Outlet } from "react-router";

export function RootLayout({ children }: PropsWithChildren) {
  return (
    <PostHogProvider>
      {children || <Outlet />}
      <Toaster />
    </PostHogProvider>
  );
}
